import type { DetailedHTMLProps, AudioHTMLAttributes, SourceHTMLAttributes } from 'react';
import { useIntl } from 'react-intl';

export type AudioProps = DetailedHTMLProps<AudioHTMLAttributes<HTMLAudioElement>, HTMLAudioElement>
                       & DetailedHTMLProps<SourceHTMLAttributes<HTMLSourceElement>, HTMLSourceElement>
                       & {
                           labelId?: string;
                         };

const Audio = ({labelId, src, type = 'audio/mp3', ...props} : AudioProps) : JSX.Element => {

  const {locale, ...intl} = useIntl();

  const label = intl.formatMessage({ id: labelId });

  return (
    <audio {...props}>
      <source src={src} type={type} />
      <track src={src} kind='captions' srcLang={locale} label={label} />
    </audio>
  );
};

export default Audio;